module.exports = __webpack_public_path__ + "static/media/pdp_car_mid-banner.f05e03c8.png";